import { render, staticRenderFns } from "./ChooseCountryDesktopSvg.vue?vue&type=template&id=bb6a8220&"
import script from "./ChooseCountryDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./ChooseCountryDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports